<template>
  <div class="ml-user-dropdown" ref="userDropdown" v-if="user">
    <div class="ml-user-toggle" @click="toggleDropdown">
      <div class="user-info" :class="{ active: isDropdownOpen }">
        <span class="user-nav-text">
          {{ user.email || ((user.firstname || '') + ' ' + (user.lastname || '')) }}
        </span>
        <div class="session-time-left">
          {{ session_expires_in || '...' }}
        </div>
      </div>
    </div>

    <div v-if="isDropdownOpen" class="ml-user-menu">
      <div class="dropdown-item" @click.prevent="onMyProfile">
        {{ $t('ACCOUNT.MY_PROFILE') }}
      </div>
      <hr />
      <div class="dropdown-item" @click.prevent="onLogOut">
        {{ $t('ACCOUNT.LOGOUT') }}
      </div>
    </div>
  </div>
</template>

<script>
import store from '@/core/services/store';
import { mapGetters } from 'vuex';
import { LOGOUT, PURGE_AUTH } from '@/core/services/store/auth.module';
import { parseJwt } from '@/core/services/jwt.service';
import dayjs from 'dayjs';

function pad(num) {
  return parseInt(num) < 10 ? '0' + num : num;
}

export default {
  name: 'UserMenuDropdown',
  data() {
    return {
      currentTime: dayjs(),
      timer: null,
      isDropdownOpen: false
    };
  },
  computed: {
    ...mapGetters(['isAuthenticated', 'user_refresh_token', 'user']),
    session_expires_in() {
      const parsed = parseJwt(this.user_refresh_token);
      const expiration = dayjs.unix(parsed.exp);
      const diff = expiration.diff(this.currentTime);

      if (isNaN(diff)) return this.$t('COMMON.LOADING');
      if (diff < 0) {
        setTimeout(() => this.show_popup(true), 2000);
        return this.$t('COMMON.LOADING');
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      if (days > 0) {
        return this.$t('COMMON.SESSION_EXPIRES_IN_DAYS', {
          days
        });  
      }

      return this.$t('COMMON.SESSION_EXPIRES_IN', {
        hours: pad(hours),
        minutes: pad(minutes),
        seconds: pad(seconds)
      });
    }
  },
  mounted() {
    this.timer = setInterval(() => {
      this.currentTime = dayjs();
    }, 1000);
    document.addEventListener('click', this.onClickOutside);
  },
  beforeDestroy() {
    clearInterval(this.timer);
    document.removeEventListener('click', this.onClickOutside);
  },
  methods: {
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },
    onClickOutside(e) {
      if (!this.$refs.userDropdown.contains(e.target)) {
        this.isDropdownOpen = false;
      }
    },
    onMyProfile() {
      this.$router.push({ name: 'ml-profile' }).catch(() => {});
      this.isDropdownOpen = false;
    },
    onLogOut() {
      const company_id = store.getters['sid'];
      this.$store.dispatch(LOGOUT);
      this.$store.commit(PURGE_AUTH);
      console.warn('onLogOut from company', company_id);
      this.$router.push('ml-login');
    }
  }
};
</script>

<style scoped>
.ml-user-dropdown {
  position: relative;
  display: inline-block;
}

.ml-user-toggle {
  cursor: pointer;
}

.user-info {
  padding: 8px 12px;
  display: flex;
  flex-direction: column;
}

.user-nav-text {
  font-size: 1.1rem;
  color: #6c7293;
}

.session-time-left {
  font-size: 0.85rem;
  color: #aaa;
}

.ml-user-menu {
  position: absolute;
  top: 100%;
  right: 0;
  width: 250px;
  background: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  z-index: 1000;
  padding: 8px 12px;
  box-shadow: 0 0 10px rgba(0,0,0,0.05);
}

.dropdown-item {
  padding: 8px 0;
  cursor: pointer;
  transition: background 0.2s;
}

.dropdown-item:hover {
  background-color: #f0f0f0;
}
</style>
